import { Constant, fontSizes } from '@/constants/constants';
import Link from 'next/link';
import React from 'react';

const TopBar = () => {
  return (
    <div className="bg-ink text-paper md:py-[3px] py-1 sm:py-1 w-full">
      <div className="container max-w-[1350px] mx-auto px-3 sm:px-5">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-1 lg:gap-0">
          {/* Headline */}
          <p className="hidden lg:flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-paper/70">
            <span className="h-px w-6 bg-gold/60" />
            Trusted US Book Publishing House · Est. 2015
          </p>

          {/* Contact Info */}
          <div className="w-full lg:w-1/2">
            <ul className={`flex flex-col px-3 md:px-0 sm:flex-row justify-center lg:justify-end items-center gap-2 sm:gap-1 ${fontSizes.sm}`}>
              <li>
                <Link 
                  href={`${Constant.PhoneNumberLink}`}
                  className=" md:animate-none animate-pulse hover:opacity-80 transition-opacity flex items-center space-x-2 px-2 py-1"
                >
                  <svg 
                    className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0 md:flex hidden" 
                    fill="currentColor" 
                    viewBox="0 0 20 20"
                  >
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  <span className="whitespace-nowrap">{Constant.PhoneNumber}</span>
                </Link>
              </li>
              <li className=" text-gray-400 md:flex hidden">|</li>
              <li className=''>
                <Link 
                  href={Constant.EmailLink}
                  className=" md:animate-none animate-pulse hover:opacity-80 transition-opacity flex items-center space-x-2 px-2 py-1"
                >
                  <svg 
                    className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0 md:flex hidden " 
                    fill="currentColor" 
                    viewBox="0 0 20 20"
                  >
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <span className="whitespace-nowrap break-all sm:break-normal">{Constant.Email}</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;